/**
 * ADMIN AUTH PROVIDER
 * ===================
 * 
 * Protects admin routes.
 * Includes session management.
 */

import { useEffect, useRef } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { getToken, getLoginType, clearAuth, isTokenExpired } from "./Api";
import { SessionProvider } from "./SessionProvider";

const AdminRoutes = () => {
  const location = useLocation();

  const token = getToken();
  const loginType = getLoginType();

  // Check token expiry on mount
  useEffect(() => {
    if (token && isTokenExpired(token)) {
      console.log("[AdminAuth] Token expired, redirecting...");
      clearAuth();
      window.location.href = "/admin-login";
    }
  }, [token]);

  // No token - redirect to admin login
  if (!token) {
    return <Navigate to="/admin-login" state={{ from: location }} replace />;
  }

  // Not admin - redirect to admin login
  if (loginType !== "admin") {
    return <Navigate to="/admin-login" state={{ from: location }} replace />;
  }

  // Wrap with SessionProvider
  return (
    <SessionProvider>
      <Outlet />
    </SessionProvider>
  );
};

export default AdminRoutes;